import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import authSlice from "../../store/auth/authSlice";
import MissionDirectorProfile from "../../shared/profile/MissionDirectorProfile";
import Avatar from "../../shared/commonComponents/Avatar";
import { OverlayTrigger, Popover } from "react-bootstrap";

const MissionDirector = (props) => {
    const dispatch = useDispatch();
    const [IsProfileOpen, setProfileOpen] = useState(false);

    const openProfile = (userId, offeringUserId, offeringId) => {
        setProfileOpen(true);
        dispatch(
            authSlice.actions.setProfileData({
                userId: userId,
                offeringUserId: offeringUserId,
                offeringId: offeringId
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userId,
                offeringUserId: offeringUserId,
                offeringId: offeringId
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };

    const popover = (
        <Popover id="popover-basic" className="profilePopover">
            <div className="popover-profile-top-section">
                <Avatar {...props.user} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {props.user.firstName + " " + props.user.lastName}
                    </div>
                    {/* v<div className="profile-teamname">{props.teamName}</div> */}
                    <div className="profile-missionname">{props.user.missionName ? props.user.missionName : ""}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{props.user.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(props.user.userId, props.user.id, props.offeringId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );

    const hideProfile = () => {
        setProfileOpen(false);
    };
    return (
        <>
            {IsProfileOpen && <MissionDirectorProfile userProfile={props.user} hideProfile={hideProfile} offeringId={props.offeringId} />}
            <div className="dean-profile">
                <div className="dean-image">
                    <div className={"dean-profile-image" + props.class} >
                        {props && props.user.profileImage && props.user.profileImage != "NA" && <img className={"avatar-img " + props.imgClass} src={props.user.profileImage} />}
                        {props && (!props.user.profileImage || props.user.profileImage == "NA") && props.user.firstName && <span>{(props.user.firstName[0].toUpperCase() + "" + props.user.lastName[0].toUpperCase())}</span>}
                    </div>
                </div>
                <div className={"dean-username " + props.deanClass}>
                    <OverlayTrigger
                        trigger="click"
                        placement="top"
                        overlay={popover}
                        rootClose
                    >
                        <span className={"dean-name"}>{props.user.firstName} {props.user.lastName}</span>
                    </OverlayTrigger>

                    {/* <span className="dean-link">DPN link</span> */}
                </div>
            </div>
        </>
    );
};

export default MissionDirector;